document.addEventListener("DOMContentLoaded", function() {
    let quickAddDrawer = document.querySelector('cart-items')
    if (quickAddDrawer) {
        let observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(m) {
                if (m.addedNodes.length) {
                    BSS_B2B.observer.cartSubject.listenCartCheckout() 
                }
            });
        });
        observer.observe(quickAddDrawer, {
            childList: true
        });
    }
     let quickAddDrawer1 = document.querySelector('.cart-drawer__body')
     console.log(quickAddDrawer1)
    if (quickAddDrawer1) {
        let observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(m) {
                if (m.addedNodes.length) {
                    console.log('test')
                    BSS_B2B.observer.cartSubject.listenCartCheckout() 
                }
            });
        });
        observer.observe(quickAddDrawer1, {
            childList: true
        });
    }
});